import { Logger } from '@cowbell/utils';
import type { LoggerAdapter } from '@cowbell/moo';

const mooLogger = new Logger({ scope: 'moo-chat' });

export const consoleLoggerAdapter: LoggerAdapter = {
  debug: (event, data) =>
    data ? mooLogger.debug(event, data) : mooLogger.debug(event),
  info: (event, data) =>
    data ? mooLogger.info(event, data) : mooLogger.info(event),
  log: (event, data) =>
    data ? mooLogger.log(event, data) : mooLogger.log(event),
  warn: (event, data) =>
    data ? mooLogger.warn(event, data) : mooLogger.warn(event),
  error: (event, data) =>
    data ? mooLogger.error(event, data) : mooLogger.error(event),
};
